
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/plus/archive",
      function () {
        return require("private-next-pages/plus/archive/index.page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/plus/archive"])
      });
    }
  